/* React imports */
import React from 'react';

/* Styling imports */
import './scss/account.scss';
import { Row, Col, Tabs } from 'antd';

import UserProfile from 'pages/account/user-profile';
import UserPlan from 'pages/account/user-plan';
import UserHistory from 'pages/account/user-history';
const { TabPane } = Tabs;
function MyAccount() {
  return (
    <div className='account-wrapper'>
      <Row>
        <Col span={24}>
          <h1 className='page-title'>My Account</h1>
        </Col>
      </Row>
      <Tabs defaultActiveKey='1'>
        <TabPane tab='Profile' key='1'>
          <Row gutter={[28, 28]}>
            <UserProfile />
            <UserPlan />
          </Row>
        </TabPane>
        <TabPane tab='Billing History' key='3'>
          <UserHistory />
        </TabPane>
      </Tabs>      
    </div>
  );
}

export default MyAccount;
